<template>
    <div class="fixed inset-0 z-[99998] bg-black/20 animate-[confirm-animate-background_0.2s]"></div>
    <div class="fixed top-[30%] left-1/2 -translate-x-1/2 -translate-y-[30%] w-[360px] z-[99999] shadow-lg animate-[confirm-animate_0.2s] bg-card text-body rounded-lg overflow-hidden border dark:border-gray-700">
        <div class="clearfix" role="dialog" aria-labelledby="modal-title">
            <div class="flex items-center text-base font-medium p-4 border-b dark:border-gray-700">
                <div>{{ title }}</div>
            </div>
            <div class="px-4 py-3">
                <div class="flex p-3 rounded-md bg-yellow-50 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-200 text-sm" role="alert">
                    <div class="me-3 pt-0.5"><i class="ye ye-triangle-exclamation text-lg"></i></div>
                    <div><span v-if="message" v-html="message"></span> {{ warnText }}</div>
                </div>
            </div>
            <div class="px-4 pb-0">
                <div class="confirm-box">
                    <label for="confirm-text" class="block mb-2 text-sm">{{ $t(`general.type`) }} "<span class="text-red-500 dark:text-red-300 font-bold">{{ confirm }}</span>" {{ $t(`general.toConfirm`) }}</label>
                    <input v-model="deleteStr" 
                        type="text" 
                        class="w-full px-3 py-2 border rounded-md bg-card focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none transition-all dark:border-gray-600" 
                        placeholder='delete *'
                        autocomplete="off"/>
                </div>
            </div>

            <div class="grid grid-cols-2 gap-4 p-4">
                <button @click="onCancel" class="btn btn-dark rounded-md w-full justify-center">{{ $t(`general.cancel`) }}</button>
                <button @click="onConfirm" class="btn btn-primary rounded-md w-full justify-center disabled:opacity-30 " :disabled="!activeDelete">{{ $t(`general.${confirm}`) }}</button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { audioBeepSound, DeleteProps } from './utils'

// withDefaults sets the default values + makes the props correctly typed as required where possible
const props = withDefaults(defineProps<DeleteProps>(), {
  title: 'Delete item',
//   message: 'Deleting will remove the item from the "table" permanently.',
  warnText: 'Once you delete, there is no way to recover it. Please be certain.',
  confirm: 'delete',
})

// Emits (optional typing – defineEmits is still recommended)
const emit = defineEmits<{
  confirm: []          // no payload
  cancel: []           // no payload
}>()

const deleteStr = ref<string>('');
const activeDelete = computed<boolean>(()=>(deleteStr.value.toLowerCase() === props.confirm))

const onConfirm = () => {
    if(activeDelete.value) {
        emit('confirm');
    }
}

const onCancel = () => {
    deleteStr.value = '';

    emit('cancel');
}

onMounted(()=>{
    audioBeepSound().play();
})
</script>

<style>
@keyframes confirm-animate {
    0%   {margin-top:-200px; opacity:0;}
    100% {margin-top: 0; opacity:1;}
}

@keyframes confirm-animate-background {
    0%   {background: rgba(0, 0, 0, 0)}
    100% {background: rgba(0, 0, 0, 0.2)}
}
</style>